import type { EmissionsSankeyItem } from "../types/dashboard";

/** GHG adds a Total root and has two business levels; ISO has three. */
export function emissionScopes(
  items: EmissionsSankeyItem[],
): EmissionsSankeyItem[] {
  return items.flatMap((item) =>
    item.code === "Total"
      ? item.categories.map((scope) => ({
          code: scope.code,
          value: scope.value,
          categories: scope.subcategories.map((category) => ({
            ...category,
            subcategories: [],
          })),
        }))
      : [item],
  );
}
